const route = [
    {//速算教材列表
        path: '/sx/quick/selected',
        component: function (resolve) {
            require(['VIEWS/math/math/quick/selected'], resolve);
        }
    },
    {//速算设置年级
        path: '/sx/quick/setclass',
        component: function (resolve) {
            require(['VIEWS/math/math/quick/setClass'], resolve);
        }
    },
    {//速算筛选题
        path: '/sx/quick/preview/:gradeid',
        component: function (resolve) {
            require(['VIEWS/math/math/quick/preview'], resolve);
        }
    },
    {//知识点视频列表页
        path: '/sx/knowledge/taskset',
        component: function (resolve) {
            require(['VIEWS/math/math/knowledge/taskset'], resolve);
        }
    },
    {//视频作业筛选页
        path: '/sx/knowledge/preview',
        component: function (resolve) {
            require(['VIEWS/math/math/knowledge/preview'], resolve);
        }
    },

    {//发同步习题 单元复习
        //sid：21小学  22初中
        //type 2 同步习题  3单元复习
        path: '/sx/testPaper/taskset/:sid/:type',
        component: function (resolve) {
            require(['VIEWS/math/math/testPaper/taskset.vue'], resolve);
        }
    },
    {//发同步习题 单元复习
        //sid：21小学  22初中
        //type 2 同步习题  3单元复习
        path: '/sx/testPaper/screen/:sid/:type',
        component: function (resolve) {
            require(['VIEWS/math/math/testPaper/screen.vue'], resolve);
        }
    },
    {//发同步习题 单元复习
        //sid：21小学  22初中
        //type 2 同步习题  3单元复习
        path: '/sx/testPaper/preview/:sid/:type',
        component: function (resolve) {
            require(['VIEWS/math/math/testPaper/preview.vue'], resolve);
        }
    },
    {//发同步习题 单元复习
        //sid：21小学  22初中
        //type 2 同步习题  3单元复习
        path: '/sx/testPaper/taskselect/:sid/:type',
        component: function (resolve) {
            require(['VIEWS/math/math/testPaper/taskselect.vue'], resolve);
        }
    },
    {//高频错题首页
        path: '/sx/wrong/index/:sid',
        component: function (resolve) {
            require(['VIEWS/math/math/wrong/index'], resolve);
        }
    },
    {//高频错题预览 type:0不带删除的预览；1带删除预览
        path: '/sx/wrong/preview/:sid/:type',
        component: function (resolve) {
            require(['VIEWS/math/math/wrong/preview'], resolve);
        }
    },
];
export default route
